import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-importacionesyexportaciones',
  templateUrl: './importacionesyexportaciones.component.html',
  styles: []
})
export class ImportacionesyexportacionesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
